<div class="psd-page">
  <app-header-style-seven></app-header-style-seven>

  <section class="psd-hero">
    <div class="psd-hero__inner">
      <div class="psd-hero__copy">
        <span class="psd-kicker">Transparency & Disclosure</span>
        <h1>Public Self Disclosure</h1>
        <p>
          Access important institutional documents, policies, committees,
          statutory disclosures, facilities, and public information of
          Fatima Michael College of Engineering &amp; Technology.
        </p>
      </div>

      <div class="psd-hero__stats">
        <article class="hero-stat-card">
          <span class="hero-stat-label">Sections</span>
          <strong>{{ menuItems.length }}</strong>
        </article>

        <article class="hero-stat-card">
          <span class="hero-stat-label">Documents</span>
          <strong>{{ totalFiles }}</strong>
        </article>

        <article class="hero-stat-card">
          <span class="hero-stat-label">Access</span>
          <strong>PDF / Web Links</strong>
        </article>

        <article class="hero-stat-card">
          <span class="hero-stat-label">Category</span>
          <strong>Institutional Disclosure</strong>
        </article>
      </div>
    </div>
  </section>

  <section class="psd-shell">
    <article class="psd-intro-card">
      <span class="section-tag">Information Desk</span>
      <h2>Browse Public Disclosure Records</h2>
      <p>
        Select a section below to view related documents and important public
        information. All files open in a new tab for quick access.
      </p>
    </article>

    <section class="psd-list-card">
      <div class="psd-list-head">
        <div>
          <span class="section-tag">Document Sections</span>
          <h3>Disclosure Categories</h3>
        </div>

        <div class="list-badge">{{ menuItems.length }} Sections</div>
      </div>

      <div class="disclosure-list">
        <article
          class="disclosure-item"
          *ngFor="let item of menuItems; let i = index; trackBy: trackByTitle"
          [class.is-open]="item.open"
        >
          <button
            type="button"
            class="disclosure-toggle"
            (click)="toggleMenu(i)"
            [attr.aria-expanded]="item.open"
          >
            <div class="disclosure-toggle__left">
              <span class="disclosure-index">{{ i + 1 }}</span>

              <div class="disclosure-title-wrap">
                <h4>{{ item.title }}</h4>
                <p>{{ item.files.length }} file{{ item.files.length > 1 ? 's' : '' }}</p>
              </div>
            </div>

            <span class="disclosure-icon">
              <i class="bx bx-chevron-down"></i>
            </span>
          </button>

          <div class="disclosure-panel" *ngIf="item.open">
            <ul class="file-list">
              <li
                class="file-item"
                *ngFor="let file of item.files; trackBy: trackByFileName"
              >
                <div class="file-meta">
                  <span class="file-type">
                    <i
                      class="bx"
                      [ngClass]="isExternalLink(file.url) ? 'bx-link-external' : 'bxs-file-pdf'"
                    ></i>
                    {{ isExternalLink(file.url) ? 'External Link' : 'PDF Document' }}
                  </span>

                  <h5>{{ file.name }}</h5>
                </div>

                <a
                  class="file-link"
                  [href]="file.url"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Open
                </a>
              </li>
            </ul>
          </div>
        </article>
      </div>
    </section>
  </section>
</div>